import { DEFAULT_WEATHER_LIMITS, KM_PER_NM } from "@/config/defaults"

// shiptypesRnwRestrictions arrives as a JSON string: '["Oil Tanker"]'.
function parseShiptypes(raw) {
  if (!raw) return ""
  try {
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr.join(", ") : String(raw)
  } catch {
    return String(raw)
  }
}

// Vessel row from GET /vessels (the RouteStore entity) → the spec-view /
// request-merge shape. The only place the API column names are mapped.
export function vesselOptionToMeta(vessel) {
  return {
    imo: vessel.imo ?? "",
    lengthM: vessel.lengthMeterRnwRestrictions ?? "",
    beamM: vessel.beamMeterRnwRestrictions ?? "",
    maxDraftM: vessel.maxdraftMeterRnwRestrictions ?? "",
    grossTonnage: vessel.grossTonnageRnwRestrictions ?? "",
    deadweightTonnes: vessel.deadweightTonnes || "",
    ciiRating: vessel.ciiRating ?? "",
    shiptype: parseShiptypes(vessel.shiptypesRnwRestrictions),
    nationality: vessel.nationalityRnwRestrictions ?? "",
    mmsi: vessel.mmsiRnwRestrictions ?? "",
    fleetname: vessel.fleetName ?? "",
    owner: vessel.fleetOwnerName ?? "",
    charterer: vessel.chartererName ?? "",
    defaultWindLimit: vessel.defaultWindLimitKn ?? "",
    defaultWaveLimit: vessel.defaultWaveLimitM ?? "",
    defaultCurrentLimit: vessel.defaultCurrentLimitKn ?? "",
  }
}

const positiveOr = (value, fallback) => {
  const num = Number(value)
  return value !== "" && value != null && num > 0 ? num : fallback
}

// Planner limit field → vessel meta default field.
export const LIMIT_DEFAULT_FIELDS = {
  windLimit: "defaultWindLimit",
  waveLimit: "defaultWaveLimit",
  currentLimit: "defaultCurrentLimit",
}

const mapLimits = (fn) =>
  Object.fromEntries(
    Object.entries(LIMIT_DEFAULT_FIELDS).map(([limit, metaField]) => [limit, fn(limit, metaField)]),
  )

// Effective weather limits for a vessel: its own default, else the system default.
export function vesselWeatherLimits(meta) {
  return mapLimits((limit, metaField) => positiveOr(meta?.[metaField], DEFAULT_WEATHER_LIMITS[limit]))
}

// Voyage entry wins, else the vessel default, else the system default.
export function resolveWeatherLimits(settings, meta) {
  const inherited = vesselWeatherLimits(meta)
  return mapLimits((limit) => positiveOr(settings?.[limit], inherited[limit]))
}

// Limits a stored route was computed with (danger_ge_kmh → kn); null if absent.
export function weatherLimitsFromRequest(jsonRequest) {
  const windKmh = Number(jsonRequest?.wind_layer?.danger_ge_kmh)
  const waveM = Number(jsonRequest?.wave_layer?.danger_ge_meter)
  const currentKmh = Number(jsonRequest?.current_layer?.danger_ge_kmh)
  const toKn = (kmh) => (kmh > 0 ? Math.round((kmh / KM_PER_NM) * 1000) / 1000 : null)
  return {
    windLimit: toKn(windKmh),
    waveLimit: waveM > 0 ? waveM : null,
    currentLimit: toKn(currentKmh),
  }
}
